module.exports = __webpack_public_path__ + "fonts/Neboma_Sporte.ed8906e0.otf";